let jobShowFunctions = (function () {
  let modules = {};
  modules.LIKE = "like";

  modules.UNLIKE = "unlike";

  modules.likeUnlikeJob = function (button, jobId, isUnLike = true) {
    modules.syncLikeStatus(jobId, isUnLike);
    let url = isUnLike
      ? Routes.destroy_favorite_jobs_path()
      : Routes.create_favorite_jobs_path();
    let submitAjax = $.ajax({
      url: url,
      method: "POST",
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        job_id: jobId,
      },
    });
    submitAjax.done(function (response) {
      button.prop("disabled", false);
    });
    submitAjax.fail(function (response) {
      commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      modules.syncLikeStatus(jobId, !isUnLike);
      button.prop("disabled", false);
    });
  };

  modules.syncLikeStatus = function (job_id, isUnLike = true) {
    if (isUnLike) {
      $(".btn-like-job[data-id=" + job_id + "]").removeClass("has-favorited");
    } else {
      $(".btn-like-job[data-id=" + job_id + "]").addClass("has-favorited");
    }
  };

  modules.entryJob = function (button) {
    let form = $("#js-form-entry-job");
    let url = form.prop('action');
    let data = new FormData(form[0]);
    let submitAjax = $.ajax({
      url: url,
      method: "POST",
      data: data,
      processData: false,
      contentType: false
    });
    submitAjax.done(function (response) {
      if (response.status) {
        window.location.href = Routes.entry_jobs_successful_path();
      } else {
        commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
        button.prop("disabled", false);
      }
    });
    submitAjax.fail(function (response) {
      commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      button.prop("disabled", false);
    });
  }

  return modules;
})(window.jQuery, window, document);

$(document).ready(function () {
  $(".js-btn-entry").on("click", function () {
    commonFunctions.disabledButtonWhenLoading($(this));
    jobShowFunctions.entryJob($(this));
  })
});

$(window).on("scroll", commonFunctions.rafThrottle(function () {
  if ($(window).scrollTop() > 5) {
    $(".job-detail__top-back").removeClass("d-none");
    $(".header-top_title").addClass("d-none");
  } else {
    $(".job-detail__top-back").addClass("d-none");
    $(".header-top_title").removeClass("d-none");
  }
}));

if ($(".job-detail--top").length > 0) {
  var $btnSticky = $(".job-detail--top");
  var $boxSticky = $(".job-detail");
  var $elmSticky = $(".job-detail_btns");

  var height = $boxSticky.innerHeight();

  $(window).on("scroll", commonFunctions.rafThrottle(function () {
    var top = $btnSticky.offset().top + 30;
    if ($(window).scrollTop() < top - $(window).height() + height + 10) {
      $elmSticky.addClass("fixed");
    } else {
      $elmSticky.removeClass("fixed");
    }
  }));
}

$(".job-detail-container, .job-detail-container-sp").on(
  "click",
  ".btn-like-job",
  function () {
    $(this).prop("disabled", true);
    jobShowFunctions.likeUnlikeJob(
      $(this),
      $(this).data("id"),
      $(this).hasClass("has-favorited")
    );
  }
);
